<!-- @if (mobileLayout.title) {
    <h3 [innerHTML]="mobileLayout.title"></h3>
} -->
@if (mobileLayout.title) {
    <sirius-heading [text]="mobileLayout.title" [h]="3" textStyleSize="xs" data-cy="table-list-title"></sirius-heading>
}
@for (table of mobileLayout.tables; track $index) {
    @if (table.subTitle) {
        <sirius-heading
            [text]="table.subTitle"
            [h]="4"
            textStyleSize="xs"
            data-cy="table-list-subtitle"></sirius-heading>
    }
    <table data-cy="table">
        @for (row of table.rows; track $index) {
            @if (row) {
                <tr data-cy="tr">
                    <th class="sir-text-style-paragraph-m-bold" [innerHTML]="row.header" data-cy="th"></th>
                    <td class="sir-text-style-paragraph-m-default" [innerHTML]="row.data" data-cy="td"></td>
                </tr>
            }
        }
    </table>
}
